export function normalizeSearchText(value: string | null | undefined): string {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

export function equalsNormalizedSearchText(
  left: string | null | undefined,
  right: string | null | undefined,
): boolean {
  return normalizeSearchText(left) === normalizeSearchText(right);
}

export function includesNormalizedSearchText(
  value: string | null | undefined,
  search: string | null | undefined,
): boolean {
  const normalizedValue = normalizeSearchText(value);
  const normalizedSearch = normalizeSearchText(search);

  if (!normalizedSearch) {
    return false;
  }

  return normalizedValue.includes(normalizedSearch);
}
